import Vue from 'vue';
import ProductMap from './ProductMap.vue';

document.querySelectorAll('.js-product-map').forEach((node) => {
    new Vue({
        el: node,
        components: {
            ProductMap
        }
    });
});
